"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCharacterSprite = void 0;
const ClothesDye_1 = require("../../../classes/ClothesDye");
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const HairDye_1 = require("../../../classes/HairDye");
const Mask_1 = require("../../../classes/Mask");
const Outfit_1 = require("../../../classes/Outfit");
const SkinColor_1 = require("../../../classes/SkinColor");
const getConstants_1 = require("../../getConstants");
const definables_1 = require("definables");
const createCharacterSprite = ({ coordinates, clothesDyeID, direction, entity, figureID, hairDyeID, maskID, outfitID, skinColorID, statusIconImagePath, }) => {
    if ((typeof entity === "undefined") ===
        (typeof coordinates === "undefined")) {
        throw new Error("Either both entity and coordinates must be defined or both must be undefined.");
    }
    const constants = (0, getConstants_1.getConstants)();
    const getClothesDye = () => (0, definables_1.getDefinable)(ClothesDye_1.ClothesDye, typeof clothesDyeID === "function" ? clothesDyeID() : clothesDyeID);
    const getHairDye = () => (0, definables_1.getDefinable)(HairDye_1.HairDye, typeof hairDyeID === "function" ? hairDyeID() : hairDyeID);
    const getMask = () => (0, definables_1.getDefinable)(Mask_1.Mask, typeof maskID === "function" ? maskID() : maskID);
    const getOutfit = () => (0, definables_1.getDefinable)(Outfit_1.Outfit, typeof outfitID === "function" ? outfitID() : outfitID);
    const getSkinColor = () => (0, definables_1.getDefinable)(SkinColor_1.SkinColor, typeof skinColorID === "function" ? skinColorID() : skinColorID);
    const recolors = () => {
        const clothesDye = getClothesDye();
        const hairDye = getHairDye();
        const skinColor = getSkinColor();
        return [
            // Clothes Primary 1
            {
                fromColor: "#0d0d0d",
                toColor: clothesDye.primaryClothesColor.color1,
            },
            // Clothes Primary 2
            {
                fromColor: "#272727",
                toColor: clothesDye.primaryClothesColor.color2,
            },
            // Clothes Secondary 1
            {
                fromColor: "#414141",
                toColor: clothesDye.secondaryClothesColor.color1,
            },
            // Clothes Secondary 2
            {
                fromColor: "#5b5b5b",
                toColor: clothesDye.secondaryClothesColor.color2,
            },
            // Hair 1
            {
                fromColor: "#757575",
                toColor: hairDye.hairColor.color1,
            },
            // Hair 2
            {
                fromColor: "#8f8f8f",
                toColor: hairDye.hairColor.color2,
            },
            // Hair 3
            {
                fromColor: "#c3c3c3",
                toColor: hairDye.hairColor.color3,
            },
            // Skin color
            {
                fromColor: "#dddddd",
                toColor: skinColor.color1,
            },
            {
                fromColor: "#f7f7f7",
                toColor: skinColor.color2,
            },
        ];
    };
    const animationID = () => {
        const animationDirection = typeof direction === "string" ? direction : direction();
        if (typeof coordinates !== "undefined") {
            if (coordinates.isAnimated === true) {
                switch (animationDirection) {
                    case retrommo_types_1.Direction.Down:
                        return "WalkDown";
                    case retrommo_types_1.Direction.Left:
                        return "WalkLeft";
                    case retrommo_types_1.Direction.Right:
                        return "WalkRight";
                    case retrommo_types_1.Direction.Up:
                        return "WalkUp";
                }
            }
            else {
                switch (animationDirection) {
                    case retrommo_types_1.Direction.Down:
                        return "IdleDownRight";
                    case retrommo_types_1.Direction.Left:
                        return "IdleLeftRight";
                    case retrommo_types_1.Direction.Right:
                        return "IdleRightRight";
                    case retrommo_types_1.Direction.Up:
                        return "IdleUpRight";
                }
            }
        }
        if (typeof entity === "undefined") {
            throw new Error("Entity is undefined.");
        }
        const step = typeof entity.step === "string" ? entity.step : entity.step();
        if (entity.animationStartedAt !== null) {
            const animationStartedAt = typeof entity.animationStartedAt === "number"
                ? entity.animationStartedAt
                : entity.animationStartedAt();
            if (animationStartedAt !== null) {
                const sinceAnimationStarted = (0, pixel_pigeon_1.getCurrentTime)() - animationStartedAt;
                if (sinceAnimationStarted < constants["movement-duration"] / 2) {
                    switch (animationDirection) {
                        case retrommo_types_1.Direction.Down:
                            switch (step) {
                                case retrommo_types_1.Step.Left:
                                    return "StepDownLeft";
                                case retrommo_types_1.Step.Right:
                                    return "StepDownRight";
                            }
                            throw new Error("Invalid step.");
                        case retrommo_types_1.Direction.Left:
                            switch (step) {
                                case retrommo_types_1.Step.Left:
                                    return "StepLeftLeft";
                                case retrommo_types_1.Step.Right:
                                    return "StepLeftRight";
                            }
                            throw new Error("Invalid step.");
                        case retrommo_types_1.Direction.Right:
                            switch (step) {
                                case retrommo_types_1.Step.Left:
                                    return "StepRightLeft";
                                case retrommo_types_1.Step.Right:
                                    return "StepRightRight";
                            }
                            throw new Error("Invalid step.");
                        case retrommo_types_1.Direction.Up:
                            switch (step) {
                                case retrommo_types_1.Step.Left:
                                    return "StepUpLeft";
                                case retrommo_types_1.Step.Right:
                                    return "StepUpRight";
                            }
                            throw new Error("Invalid step.");
                    }
                }
            }
        }
        switch (animationDirection) {
            case retrommo_types_1.Direction.Down:
                switch (step) {
                    case retrommo_types_1.Step.Left:
                        return "IdleDownLeft";
                    case retrommo_types_1.Step.Right:
                        return "IdleDownRight";
                }
                throw new Error("Invalid step.");
            case retrommo_types_1.Direction.Left:
                switch (step) {
                    case retrommo_types_1.Step.Left:
                        return "IdleLeftLeft";
                    case retrommo_types_1.Step.Right:
                        return "IdleLeftRight";
                }
                throw new Error("Invalid step.");
            case retrommo_types_1.Direction.Right:
                switch (step) {
                    case retrommo_types_1.Step.Left:
                        return "IdleRightLeft";
                    case retrommo_types_1.Step.Right:
                        return "IdleRightRight";
                }
                throw new Error("Invalid step.");
            case retrommo_types_1.Direction.Up:
                switch (step) {
                    case retrommo_types_1.Step.Left:
                        return "IdleUpLeft";
                    case retrommo_types_1.Step.Right:
                        return "IdleUpRight";
                }
                throw new Error("Invalid step.");
        }
    };
    const animationStartedAt = 0;
    const duration = constants["movement-duration"];
    const tileSize = constants["tile-size"];
    const width = tileSize;
    const height = tileSize;
    const animations = [
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 32,
                    sourceY: 0,
                    width,
                },
            ],
            id: "IdleDownLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: 0,
                    width,
                },
            ],
            id: "IdleDownRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 32,
                    sourceY: 16,
                    width,
                },
            ],
            id: "IdleLeftLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: 16,
                    width,
                },
            ],
            id: "IdleLeftRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 32,
                    sourceY: 32,
                    width,
                },
            ],
            id: "IdleRightLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: 32,
                    width,
                },
            ],
            id: "IdleRightRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 32,
                    sourceY: 48,
                    width,
                },
            ],
            id: "IdleUpLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: 48,
                    width,
                },
            ],
            id: "IdleUpRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 48,
                    sourceY: 0,
                    width,
                },
            ],
            id: "StepDownLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 16,
                    sourceY: 0,
                    width,
                },
            ],
            id: "StepDownRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 48,
                    sourceY: 16,
                    width,
                },
            ],
            id: "StepLeftLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 16,
                    sourceY: 16,
                    width,
                },
            ],
            id: "StepLeftRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 48,
                    sourceY: 32,
                    width,
                },
            ],
            id: "StepRightLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 16,
                    sourceY: 32,
                    width,
                },
            ],
            id: "StepRightRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 48,
                    sourceY: 48,
                    width,
                },
            ],
            id: "StepUpLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 16,
                    sourceY: 48,
                    width,
                },
            ],
            id: "StepUpRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: 0,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize,
                    sourceY: 0,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 2,
                    sourceY: 0,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 3,
                    sourceY: 0,
                    width,
                },
            ],
            id: "WalkDown",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: tileSize,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize,
                    sourceY: tileSize,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 2,
                    sourceY: tileSize,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 3,
                    sourceY: tileSize,
                    width,
                },
            ],
            id: "WalkLeft",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: tileSize * 2,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize,
                    sourceY: tileSize * 2,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 2,
                    sourceY: tileSize * 2,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 3,
                    sourceY: tileSize * 2,
                    width,
                },
            ],
            id: "WalkRight",
        },
        {
            frames: [
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: 0,
                    sourceY: tileSize * 3,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize,
                    sourceY: tileSize * 3,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 2,
                    sourceY: tileSize * 3,
                    width,
                },
                {
                    duration,
                    height,
                    sourceHeight: height,
                    sourceWidth: width,
                    sourceX: tileSize * 3,
                    sourceY: tileSize * 3,
                    width,
                },
            ],
            id: "WalkUp",
        },
    ];
    // Head back sprite
    const headBackSpriteCondition = () => typeof getMask().headCosmetic.backImagePaths[typeof figureID === "function" ? figureID() : figureID] !== "undefined";
    const headBackSpriteID = (0, pixel_pigeon_1.createSprite)({
        animationID,
        animationStartedAt,
        animations,
        coordinates: typeof coordinates !== "undefined"
            ? {
                condition: () => {
                    if (typeof coordinates.condition === "undefined" ||
                        coordinates.condition()) {
                        return headBackSpriteCondition();
                    }
                    return false;
                },
                x: coordinates.x,
                y: coordinates.y,
            }
            : undefined,
        imagePath: () => getMask().headCosmetic.backImagePaths[typeof figureID === "function" ? figureID() : figureID],
        recolors,
    });
    // Body sprite
    const bodySpriteCondition = () => typeof getOutfit().bodyCosmetic.imagePaths[typeof figureID === "function" ? figureID() : figureID] !== "undefined";
    const bodySpriteID = (0, pixel_pigeon_1.createSprite)({
        animationID,
        animationStartedAt,
        animations,
        coordinates: typeof coordinates !== "undefined"
            ? {
                condition: () => {
                    if (typeof coordinates.condition === "undefined" ||
                        coordinates.condition()) {
                        return bodySpriteCondition();
                    }
                    return false;
                },
                x: coordinates.x,
                y: coordinates.y,
            }
            : undefined,
        imagePath: () => getOutfit().bodyCosmetic.imagePaths[typeof figureID === "function" ? figureID() : figureID],
        recolors,
    });
    // Head front sprite
    const headFrontSpriteCondition = () => typeof getMask().headCosmetic.frontImagePaths[typeof figureID === "function" ? figureID() : figureID] !== "undefined";
    const headFrontSpriteID = (0, pixel_pigeon_1.createSprite)({
        animationID,
        animationStartedAt,
        animations,
        coordinates: typeof coordinates !== "undefined"
            ? {
                condition: () => {
                    if (typeof coordinates.condition === "undefined" ||
                        coordinates.condition()) {
                        return headFrontSpriteCondition();
                    }
                    return false;
                },
                x: coordinates.x,
                y: coordinates.y,
            }
            : undefined,
        imagePath: () => getMask().headCosmetic.frontImagePaths[typeof figureID === "function" ? figureID() : figureID],
        recolors,
    });
    // Status icon sprite
    const statusIconSpriteCondition = () => {
        const statusIconImagePathValue = typeof statusIconImagePath === "function"
            ? statusIconImagePath()
            : statusIconImagePath;
        return typeof statusIconImagePathValue !== "undefined";
    };
    const statusIconSpriteID = (0, pixel_pigeon_1.createSprite)({
        animationID: "default",
        animations: [
            {
                frames: [
                    {
                        height: 8,
                        sourceHeight: 8,
                        sourceWidth: 8,
                        sourceX: 0,
                        sourceY: 0,
                        width: 8,
                    },
                ],
                id: "default",
            },
        ],
        coordinates: typeof coordinates !== "undefined"
            ? {
                condition: () => {
                    if (typeof coordinates.condition === "undefined" ||
                        coordinates.condition()) {
                        return statusIconSpriteCondition();
                    }
                    return false;
                },
                x: () => (typeof coordinates.x === "function"
                    ? coordinates.x()
                    : coordinates.x) + 4,
                y: () => (typeof coordinates.y === "function"
                    ? coordinates.y()
                    : coordinates.y) + 12,
            }
            : undefined,
        imagePath: () => {
            const statusIconImagePathValue = typeof statusIconImagePath === "function"
                ? statusIconImagePath()
                : statusIconImagePath;
            if (typeof statusIconImagePathValue === "undefined") {
                throw new Error("Status icon image path is undefined.");
            }
            return statusIconImagePathValue;
        },
    });
    if (typeof entity !== "undefined") {
        (0, pixel_pigeon_1.addEntitySprite)(entity.entityID, {
            condition: headBackSpriteCondition,
            spriteID: headBackSpriteID,
        });
        (0, pixel_pigeon_1.addEntitySprite)(entity.entityID, {
            condition: bodySpriteCondition,
            spriteID: bodySpriteID,
        });
        (0, pixel_pigeon_1.addEntitySprite)(entity.entityID, {
            condition: headFrontSpriteCondition,
            spriteID: headFrontSpriteID,
        });
        (0, pixel_pigeon_1.addEntitySprite)(entity.entityID, {
            condition: statusIconSpriteCondition,
            spriteID: statusIconSpriteID,
        });
    }
};
exports.createCharacterSprite = createCharacterSprite;
